export default function calculatePrice(
  freq,
  bedrooms,
  bathrooms,
  addons,
  discount
) {
  const perBdRoom = bedrooms > 3 ? 25 : 15;
  const perBath = 17;
  const baseCost = 50.34;
  const serviceRates = {
    oneTime: 1,
    everyWeek: 0.8,
    twoWeeks: 0.85,
    fourWeeks: 0.9
  };
  const disc = discount ? discount : 0;
  const total =
    (baseCost + bedrooms * perBdRoom + bathrooms * perBath) *
      serviceRates[freq] -
    disc;
  return total.toFixed(2);
}



// WEBPACK FOOTER //
// ./src/utilities/priceCalculator.js